// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".settings-hint[data-v-51c28e7e]{margin-top:-12px;margin-bottom:6px;color:var(--color-text-maxcontrast)}label[data-v-51c28e7e]{padding-right:12px}\n", ""]);
// Exports
module.exports = exports;
